var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    attrs: {
      "refs": "form"
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Name'),
      "counter": 20,
      "rules": _vm.rules,
      "required": "",
      "outlined": ""
    },
    on: {
      "input": function ($event) {
        return _vm.update('type', _vm.value);
      }
    },
    model: {
      value: _vm.value.name,
      callback: function ($$v) {
        _vm.$set(_vm.value, "name", $$v);
      },
      expression: "value.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Pumo No.'),
      "counter": 1,
      "type": "number",
      "rules": [_vm.rules[0]],
      "required": "",
      "outlined": ""
    },
    on: {
      "input": function ($event) {
        return _vm.update('type', _vm.value);
      }
    },
    model: {
      value: _vm.value.pump_no,
      callback: function ($$v) {
        _vm.$set(_vm.value, "pump_no", _vm._n($$v));
      },
      expression: "value.pump_no"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Terminal'),
      "items": _vm.term,
      "item-text": "name",
      "item-value": "id",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.value.terminal_id,
      callback: function ($$v) {
        _vm.$set(_vm.value, "terminal_id", $$v);
      },
      expression: "value.terminal_id"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Dispenser'),
      "items": _vm.disp,
      "item-text": "name",
      "item-value": "id",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.value.dispenser_id,
      callback: function ($$v) {
        _vm.$set(_vm.value, "dispenser_id", _vm._n($$v));
      },
      expression: "value.dispenser_id"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Tagreader'),
      "items": _vm.reads,
      "item-text": "name",
      "item-value": "id",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.value.tagreader_id,
      callback: function ($$v) {
        _vm.$set(_vm.value, "tagreader_id", _vm._n($$v));
      },
      expression: "value.tagreader_id"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('Active'),
      "color": "indigo darken-3",
      "true-value": 1,
      "false-value": 0
    },
    on: {
      "input": function ($event) {
        return _vm.update('type', _vm.value);
      }
    },
    model: {
      value: _vm.value.status,
      callback: function ($$v) {
        _vm.$set(_vm.value, "status", _vm._n($$v));
      },
      expression: "value.status"
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }